import type { FC } from 'react';

import { getSectionLink } from '../hooks/useSectionNav.hook';
import { type TocHeadingNode,useTableOfContents } from '../hooks/useTableOfContents';

export interface ToCEditorProps {}

export const ToCEditor: FC<ToCEditorProps> = () => {
    const { sections } = useTableOfContents();

    return (
        <div className='flex flex-col gap-6 px-1 md:px-0'>
            {sections.length > 0 && (
                <ul className='flex flex-col gap-2 [list-style-type:disc] pl-12'>
                    {sections.map((section) => (
                        <li key={section.sectionId}>
                            <a
                                href={getSectionLink(section.sectionId)}
                                className='block hyperlink'
                            >{section.sectionTitle}</a>
                            {section.headings.length > 0 && (
                                <ul className='flex flex-col gap-2 [list-style-type:disc] pl-8 pt-2 pb-2'>
                                    {section.headings.map((heading) => (
                                        <ToCHeading key={heading.heading.path.join('-')} node={heading} />
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            )}
            {!sections.length && (
                <div className='text-gray-500 text-left border border-gray-300 text-sm p-4 rounded-lg'>V dokumentu nebyly nalezeny žádné sekce.</div>
            )}
        </div>
    );
};

const ToCHeading: FC<{ node: TocHeadingNode }> = ({ node }) => {
    return (
        <li>
            <a
                href={getSectionLink(node.heading.sectionId, node.heading.headingId)}
                className='block hyperlink'
            >{node.heading.headingTitle}</a>

            {node.children.length > 0 && (
                <ul className='flex flex-col gap-2 [list-style-type:disc] pl-8 pt-2'>
                    {node.children.map((child) => (
                        <ToCHeading key={child.heading.path.join('-')} node={child} />
                    ))}
                </ul>
            )}
        </li>
    );
};
